'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["banner", "body", "bodyProps", "bodyStyle", "bodyTitle", "dialogTitle", "id", "footer", "navStepper", "onClose", "onEscape", "className", "colorSet", "aria-label", "subtitle", "hasFooterStyleReset"];
import React, { useEffect } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { deprecatedPropWarning } from "../../logging.mjs";
import { addColorSet } from "../../styles/index.mjs";
import { IconX } from "../Icon/icons/IconX/index.mjs";
import { Body } from "./Body.mjs";
import { BodyTitle } from "./BodyTitle.mjs";
import { CloseButton } from "./CloseButton.mjs";
import { Container } from "./Container.mjs";
import { Footer } from "./Footer.mjs";
import { FooterNav } from "./FooterNav.mjs";
import { Header } from "./Header.mjs";
import { HeaderNav } from "./HeaderNav.mjs";
import { HeaderTitle } from "./HeaderTitle.mjs";
import { Subtitle } from "./Subtitle.mjs";
export var DialogFullScreen = /*#__PURE__*/React.forwardRef(function DialogFullScreen(_ref, ref) {
  var banner = _ref.banner,
    body = _ref.body,
    bodyProps = _ref.bodyProps,
    bodyStyle = _ref.bodyStyle,
    bodyTitle = _ref.bodyTitle,
    dialogTitle = _ref.dialogTitle,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'encore-web-dialog-fullscreen' : _ref$id,
    footer = _ref.footer,
    navStepper = _ref.navStepper,
    onClose = _ref.onClose,
    onEscape = _ref.onEscape,
    className = _ref.className,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Close' : _ref$ariaLabel,
    subtitle = _ref.subtitle,
    hasFooterStyleReset = _ref.hasFooterStyleReset,
    props = _objectWithoutProperties(_ref, _excluded);
  if (navStepper) {
    deprecatedPropWarning('navStepper', 'DialogFullScreen', 'For stepped flows, use the `subtitle` prop with text (for mobile or desktop) or a `NavStepper` (desktop only).');
  }
  useEffect(function () {
    var onKeydown = function onKeydown(event) {
      if ((event.keyCode === 27 || event.code === 'Escape') && onEscape) {
        onEscape(event);
      }
    };
    window.addEventListener('keydown', onKeydown, true);
    return function cleanup() {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  var titleId = id && "".concat(id, "-title");
  return /*#__PURE__*/React.createElement(Container, Object.assign({
    ref: ref,
    colorSet: colorSet,
    className: addColorSet(colorSet, className),
    "aria-labelledby": titleId
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.DialogFullScreen
  }), banner, dialogTitle && /*#__PURE__*/React.createElement(Header, {
    colorSet: colorSet
  }, /*#__PURE__*/React.createElement(HeaderTitle, null, dialogTitle), subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle), navStepper && /*#__PURE__*/React.createElement(HeaderNav, null, navStepper), onClose && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose,
    "aria-label": ariaLabel,
    iconOnly: IconX,
    type: "button"
  })), /*#__PURE__*/React.createElement(Body, Object.assign({
    style: bodyStyle
  }, bodyProps), bodyTitle && /*#__PURE__*/React.createElement(BodyTitle, {
    id: titleId
  }, bodyTitle), body), (navStepper || footer) && /*#__PURE__*/React.createElement(Footer, {
    hasFooterStyleReset: hasFooterStyleReset,
    colorSet: colorSet,
    "data-testid": "dialog-footer"
  }, navStepper && /*#__PURE__*/React.createElement(FooterNav, null, navStepper), footer));
});